import { lang } from '@umu/ukit-lang';
import { IColorConfig, IIconInfo, IIconItemInfo, IMAGE_TYPE } from './interface';

const defaultIconColor = '#000';
const MAX_FILE_SIZE = 1024 * 50; // 最大文件大小50K
/**
 * @desc 默认颜色配置
 */
const defaultColorConfig: IColorConfig = {
    restColor: '#FAB400',
    isAllowRest: true,
    restText: lang('重置'),
    title: lang('你也可以在下方图标中选择'),
    prefixText: lang('选中图标的颜色：'),
};
/**
 * @desc 获取图标选择列表
 */
const getImageSelectList = (info: IIconInfo, isOnlyShowActive = false) => {
    return isOnlyShowActive ? [
        {
            titleText: lang('图标'),
            iconName: info.activeIconName || info.iconName,
            color: info.color,
            iconType: info.iconType,
            imgSrc: info.activeIcon,
            isAllowReset: true,
            className: 'icon-info-element',
        },
    ]: [
        {
            titleText: lang('默认图标'),
            iconName: info.iconName,
            color: info?.normalColor || defaultIconColor,
            iconType: info.iconType,
            imgSrc: info.normalIcon,
            isAllowReset: true,
            className: 'icon-info-element',
        },
        {
            titleText: lang('选中图标'),
            iconName: info.activeIconName || info.iconName,
            color: info.color,
            iconType: info.iconType,
            imgSrc: info.activeIcon,
            isAllowReset: true,
            className: 'icon-info-element',
        },
    ];
};
/**
 * @desc 将svg图标转换为数据
 */
const onTransformData = (data: IIconItemInfo): IIconInfo => {
    return {
        iconName: data.iconName,
        activeIconName: data.activeIconName || data.iconName,
        iconType: IMAGE_TYPE.SVG,
        svgUrl: data.url,
        activeSvgUrl: data.activeUrl || data.url,
    } as IIconInfo;
};

export { getImageSelectList, onTransformData, defaultIconColor, MAX_FILE_SIZE, defaultColorConfig };
